import { SubscriptionAnalyticsDashboard } from '@client/pages/metabase/SubscriptionAnalyticsDashboard';
import { OTPDashboard } from '@client/pages/metabase/OTPDashboard';
import { FreeOffersDashboard } from '@client/pages/metabase/FreeOffersDashboard';
import { TabHash } from './useInfluencerAnalyticsTabs';

type AnalyticsTabContentProps = { hash: TabHash };

export const AnalyticsTabContent = (p: AnalyticsTabContentProps) => {
  switch (p.hash) {
    case 'subscriptions':
      return <SubscriptionAnalyticsDashboard />;
    case 'otps':
      return <OTPDashboard />;
    case 'free':
      return <FreeOffersDashboard />;
  }
};
